import { StyleSheet, Dimensions, Platform } from 'react-native';

export default StyleSheet.create({
  txtheadingQuick: {
    paddingTop: 10,
    textAlign: 'center',
    fontSize: 18,
    fontFamily: Platform.OS === 'ios' ? 'SFProTextbold' : 'SFProText',
  },
  backGroundChat: {
    backgroundColor: '#a8c1d4',
  },
  quickChatContainerView: {
    height: 250,
    width: '100%',
    backgroundColor: '#cce0ff',
  },

  sidebarTxtHeading: {
    fontSize: 20,
    textAlign: 'left',
    color: '#273a4e',
    //textAlign: "center",
    fontFamily: 'SFProText',
    fontSize: 16,
    fontWeight: '500',
  },
  sideBarHeading: {
    width: 122,
    height: 19,
    justifyContent: 'center',
    alignContent: 'center',
    margin: 20,
  },
  sideBar: {
    width: '30%',

    // borderRightColor: "#e8edf2",
    // borderRightWidth: 1,
    // borderStyle: "solid",
    maxHeight: Dimensions.get('window').height,
    backgroundColor: 'white',
    overflow: 'hidden',
    justifyContent: 'space-between',
  },

  sideBar_SMALL_MOBILE: {
    alignItems: 'center',
    width: '100%',
  },
  sideBar_MEDIUM_MOBILE: {
    width: '100%',

    alignItems: 'center',
  },
  sideBar_LARGE_MOBILE: {
    alignItems: 'center',
    width: '100%',
  },
  sideBar_SMALL_TABLET: {
    alignItems: 'center',
    width: '100%',
  },
  sideBar_MEDIUM_TABLET: {
    width: '35%',
  },
  sideBar_LARGE_TABLET: {
    width: '30%',
  },
  sideBar_LAPTOP: {
    width: '25%',
  },
  IconRoomsImage: { height: 50, width: 50 },

  rightSideChat: {
    marginRight: 10,
    marginBottom: 10,
    maxWidth: 300,
    padding: 10,
    justifyContent: 'center',
    minWidth: 20,
    minHeight: 40,
    backgroundColor: 'blue',
    alignSelf: 'flex-end',
    borderRadius: 20,
  },

  jsonformatstyle: {},

  leftSideChat: {
    maxWidth: 300,
    marginBottom: 10,
    padding: 10,
    justifyContent: 'center',
    minWidth: 20,
    minHeight: 40,
    backgroundColor: '#e4e4e4',
    alignSelf: 'flex-start',
    borderRadius: 20,
  },
  chatmsgTxtRight: {
    justifyContent: 'center',
    textAlign: 'center',
    color: 'white',
    alignItems: 'center',
    textAlign: 'left',
  },
  chatmsgTxtLeft: {
    color: 'black',
    alignItems: 'center',
    textAlign: 'left',
  },

  viewEachRoom: {
    borderBottomColor: '#e8edf2',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    alignItems: 'center',
    backgroundColor: 'white',
    flexDirection: 'row',
    marginVertical: 10,
    marginLeft: 10,
    padding: 5,
    alignContent: 'center',
    justifyContent: 'flex-start',
  },
  closeIconView: {
    // width: "100%",
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: 20,
    marginLeft: 20,
  },
  closeIcon: {
    width: 20,
    height: 20,
  },
  menuView: {
    position: 'absolute',
    marginLeft: 20,
    top: 2,
  },
  menuIcon: {
    width: 30,
    height: 35,
  },
  chatContainer: {
    width: '100%',
    // width: 950,
    height: 570,
    marginTop: 40,
    // marginLeft: 12,
    marginBottom: 50,
    padding: 15,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#dbe5ed',
    backgroundColor: '#f9fafc',
    // overflow: "scroll",
  },

  sideBar_SMALL_MOBILE: {
    width: '100%',
    padding: 10,
    margin: 0,
  },
  chatbox_MEDIUM_MOBILE: {
    width: '100%',
    padding: 10,
    margin: 0,
  },
  chatbox_LARGE_MOBILE: {
    width: '100%',
    padding: 10,
    margin: 0,
  },
  chatbox_SMALL_TABLET: {
    width: '100%',
    padding: 10,
    margin: 0,
  },
  chatbox_MEDIUM_TABLET: {
    width: '64%',
  },
  chatbox_LARGE_TABLET: {
    width: '69%',
  },
  chatbox_LAPTOP: {
    width: '74%',
  },

  wnsLogo: {
    width: 111,
    height: 39,
    top: 20,
    left: 32,
    marginTop: 17,
    marginRight: 239,
    marginBottom: 20,
    marginLeft: 8,
  },
  line: {
    width: 330,
    height: 0,
    marginTop: 20,
    marginRight: 19.5,
    marginBottom: 10,
    marginLeft: 8.5,
    borderWidth: 1,
    borderColor: '#dbe5ed',
  },
  sendBox: {
    flexDirection: 'row',
    // width: 910,
    height: 60,
    marginTop: 15,
    borderWidth: 1,
    borderColor: '#dbe5ed',
    borderRadius: 30,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sendBox_SMALL_MOBILE: {
    width: '100%',
  },
  sendBox_MEDIUM_MOBILE: {
    width: '100%',
  },
  sendBox_LARGE_MOBILE: {
    width: '100%',
  },
  sendBox_SMALL_TABLET: {
    width: '100%',
  },
  sendBox_MEDIUM_TABLET: {
    width: '100%',
  },
  sendBox_LARGE_TABLET: {
    width: '100%',
  },
  sendBox_LAPTOP: {
    width: '100%',
  },
  inputText: {
    width: '100%',
    // width: 910,
    fontFamily: 'SFProText',
    fontSize: 15,
    color: 'black',
    padding: 7,
    paddingTop: 7,
    paddingRight: 7,
    paddingLeft: 45,
    // outline: "none",
    // overflow: "hidden",
  },
  sendView: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: '#f14d31',
    //marginLeft: 578,
    paddingTop: 12,
    paddingRight: 8.5,
    paddingBottom: 12,
    paddingLeft: 9,
    marginRight: 5,
  },
  send: {
    width: 28.5,
    height: 22,
  },

  customerButtons: {
    width: 100,
    height: 20,
    color: 'black',
    marginLeft: 20,
    marginTop: 3,
    cursor: 'pointer',
    textAlign: 'center',
  },
  backgroundConnected: {
    backgroundColor: 'green',
  },
  backgroundConnect: {
    backgroundColor: '#99e6ff',
  },
  backgroundDisconnected: {
    backgroundColor: 'grey',
  },
  backGroundChat: {
    backgroundColor: '#a8c1d4',
  },
  txtRoomName: {
    marginLeft: 10,
    //fontWeight: "bold",
    fontSize: 16,
    color: '#273a4e',
    fontFamily: 'SFProText',
    textTransform: 'capitalize',
  },

  IconRoomsImage: { height: 50, width: 50 },
  viewEachRoom: {
    borderBottomColor: '#e8edf2',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    alignItems: 'center',
    backgroundColor: 'white',
    flexDirection: 'row',
    marginVertical: 10,
    marginLeft: 10,
    padding: 5,
    alignContent: 'center',
    justifyContent: 'flex-start',
  },
  logout: {
    width: 31.6,
    height: 31.6,
    position: 'relative',
  },
  logoutView: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: 20,
  },
  logoutText: {
    textAlign: 'center',
    alignSelf: 'center',
    marginLeft: 10,
    fontFamily: 'SFProText',
    fontSize: 22,
    fontWeight: 500,
    color: '#f14d31',
    width: 74,
    height: 26,
  },
  row: { flexDirection: 'row' },
});
